<mat-form-field appearance="outline" bmTheme="lang-select">
  <mat-label>{{ lg.footer.language.title }}</mat-label>
  <mat-select [(value)]="language" (selectionChange)="changeLanguage($event)">
    @for (l of languageList; track l) {
      <mat-option [value]="l.key">
        {{ l.descr }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
